var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-error-page"},[_c('div',{staticClass:"error-page-main",class:_vm.errorInfo.errorClass},[_c('p',[_vm._v(_vm._s(_vm.errorInfo.errorTxt))])])])}
var staticRenderFns = []

export { render, staticRenderFns }